<tc-setup-grid
        #setupGrid
        [colDefConfig]="colDefConfig"
        [setupGridComp]="this"
        [dataSource]="this"
        [noSelection]="true"
        [disableAdd]="isDisabledAdd()"
        [disableDelete]=true
        [disableRowDelete]=true>
</tc-setup-grid>